import { Link } from 'react-router-dom';

export default function ProductGrid() {
  const products = [
    {
      id: 1,
      name: 'Adobe PDF Library SDK',
      category: '工具',
      description: '基于Adobe Acrobat技术的企业级PDF开发工具包，提供完整的PDF创建、编辑、渲染和处理功能。支持C/C++、.NET、Java等多种开发语言，为企业应用提供可靠的PDF集成解决方案。',
      features: ['Adobe核心技术', '多语言支持', '企业级稳定性', '完整API覆盖'],
      price: '联系销售',
      image: 'https://public.readdy.ai/ai/img_res/d182382b3ad1492f9c11d1fa65781b78.jpg',
      popular: false
    },
    {
      id: 2,
      name: 'Adobe PDF Converter',
      category: '工具',
      description: '基于Adobe Distiller的专业PDF转换SDK，支持将PostScript (PS)、Encapsulated PostScript (EPS)、JPEG、BMP、TIFF、PNG和PPML文件转换为PDF。提供批量处理和高度可定制功能，可精确控制字体嵌入、颜色管理、文件类型等转换参数，满足企业级转换需求。',
      features: ['支持多种格式', '批量处理', '字体管理', '颜色管理', 'PDF/A和PDF/X', '自定义设置'],
      price: '¥20843/年起',
      image: 'https://readdy.ai/api/search-image?query=Clean%20white%20background%20minimalist%20illustration%20of%20document%20conversion%20process%20with%20simple%20geometric%20file%20format%20icons%20transforming%20into%20PDF%2C%20flat%20vector%20art%20style%20with%20subtle%20teal%20and%20cyan%20accents%20on%20white%2C%20abstract%20conversion%20arrows%20and%20file%20transformation%20elements%2C%20modern%20minimal%20design%20with%20white%20background%20and%20light%20teal%20geometric%20shapes&width=600&height=400&seq=converter-white-teal-minimal-2&orientation=landscape',
      popular: false
    },
    {
      id: 3,
      name: 'PDF Form Extension SDK',
      category: '工具',
      description: '专业的PDF表单处理开发工具包，全面支持静态XFA、动态XFA和AcroForms的创建、填写、验证和扁平化处理。提供完整的表单字段操作API，支持复杂表单逻辑、JavaScript执行、数字签名集成和表单数据的导入导出功能，为企业级表单应用开发提供强大的技术基础。',
      features: ['XFA表单支持', '表单扁平化', '数字签名', 'JavaScript执行', '数据验证', '字段操作API'],
      price: '¥13,893/年起',
      image: 'https://readdy.ai/api/search-image?query=Clean%20white%20background%20minimalist%20illustration%20of%20interactive%20digital%20forms%20with%20simple%20geometric%20input%20fields%2C%20checkboxes%20and%20form%20elements%2C%20flat%20vector%20art%20style%20with%20subtle%20teal%20and%20cyan%20accents%20on%20white%2C%20abstract%20form%20interface%20components%2C%20modern%20minimal%20design%20with%20white%20background%20and%20light%20teal%20geometric%20form%20symbols&width=600&height=400&seq=forms-white-teal-minimal-3&orientation=landscape',
      popular: false
    },
    {
      id: 4,
      name: 'PDF Forms Flattener',
      category: '工具',
      description: '专业的PDF表单扁平化命令行工具,可将AcroForm、静态XFA和动态XFA表单内容转换为标准的扁平化PDF文档。自动处理注释显示需求,确保扁平化后的文档在所有PDF查看器中保持一致的显示效果,防止进一步编辑。',
      features: ['表单扁平化', '外观流生成', 'JavaScript支持', 'XFA转AcroForm', '数据导入导出', '打印/屏幕优化'],
      price: '¥20,843/年起',
      image: 'https://readdy.ai/api/search-image?query=Clean%20white%20background%20minimalist%20illustration%20of%20PDF%20form%20flattening%20process%20with%20simple%20geometric%20shapes%20showing%20interactive%20form%20fields%20being%20converted%20to%20static%20content%2C%20flat%20vector%20art%20style%20with%20subtle%20teal%20and%20cyan%20accents%20on%20white%2C%20abstract%20form%20transformation%20elements%2C%20modern%20minimal%20design%20with%20white%20background%20and%20light%20teal%20geometric%20flatten%20symbols&width=600&height=400&seq=flattener-white-teal-minimal-6&orientation=landscape',
      popular: false
    },
    {
      id: 5,
      name: 'PDF Optimizer',
      category: '工具',
      description: '专业的PDF性能优化命令行工具，在不影响文档质量的前提下提升PDF性能。精细调整图像压缩选项，智能管理内容保留策略，让文档下载更快、打开更流畅、打印和归档更高效。支持PDF/A归档标准、色彩管理和批量处理。',
      features: ['自定义设置', '长期保存', '色彩管理', '批量处理', '图像处理', '扁平化透明度'],
      price: '¥20,843/年起',
      image: 'https://readdy.ai/api/search-image?query=Clean%20white%20background%20minimalist%20illustration%20of%20PDF%20optimization%20process%20with%20simple%20geometric%20shapes%20showing%20file%20compression%20and%20performance%20enhancement%2C%20flat%20vector%20art%20style%20with%20subtle%20teal%20and%20cyan%20accents%20on%20white%2C%20abstract%20optimization%20elements%20and%20speed%20indicators%2C%20modern%20minimal%20design%20with%20white%20background%20and%20light%20teal%20geometric%20compress%20symbols&width=600&height=400&seq=optimizer-white-teal-minimal-7&orientation=landscape',
      popular: false
    },
    {
      id: 6,
      name: 'Adobe InDesign Server',
      category: '工具',
      description: '强大的自动化排版和出版服务器解决方案，基于Adobe InDesign引擎，支持大规模文档自动化生成、模板化排版和多渠道内容发布。提供完整的服务器端API，可无缝集成企业工作流，实现高效的批量文档制作、动态内容生成和跨媒体出版，是企业级出版和营销自动化的理想选择。',
      features: ['自动化排版', '模板引擎', '批量生成', '多渠道发布', '服务器端API', '工作流集成'],
      price: '联系销售',
      image: 'https://readdy.ai/api/search-image?query=Clean%20white%20background%20minimalist%20illustration%20of%20automated%20publishing%20server%20with%20simple%20geometric%20shapes%20representing%20document%20layout%20templates%20and%20content%20automation%20workflow%2C%20flat%20vector%20art%20style%20with%20subtle%20teal%20and%20cyan%20accents%20on%20white%2C%20abstract%20server%20infrastructure%20and%20publishing%20elements%2C%20modern%20minimal%20design%20with%20white%20background%20and%20light%20teal%20geometric%20automation%20symbols&width=600&height=400&seq=indesign-server-white-teal-minimal-5&orientation=landscape',
      popular: false
    },
    {
      id: 7,
      name: 'pdfRest API Toolkit Container',
      category: '工具',
      description: '高性能的云端PDF处理API服务，提供RESTful接口，支持大规模文档处理和实时转换。',
      features: ['RESTful API', '高并发', '全球CDN', '实时处理'],
      price: '联系销售',
      image: 'https://readdy.ai/api/search-image?query=Clean%20white%20background%20minimalist%20illustration%20of%20cloud%20API%20services%20with%20simple%20geometric%20shapes%20representing%20containerized%20services%20and%20REST%20endpoints%2C%20flat%20vector%20art%20style%20with%20subtle%20teal%20and%20cyan%20accents%20on%20white%2C%20abstract%20cloud%20computing%20and%20API%20elements%2C%20modern%20minimal%20design%20with%20white%20background%20and%20light%20teal%20geometric%20cloud%20symbols&width=600&height=400&seq=api-white-teal-minimal-4&orientation=landscape',
      popular: false
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">产品矩阵</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            从开发工具到企业平台，我们提供完整的PDF文档处理产品线，满足不同规模企业的多样化需求
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-product-shop>
          {products.map((product) => (
            <div key={product.id} className="bg-white rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group flex flex-col h-full">
              {product.popular && (
                <div className="bg-gradient-to-r from-teal-600 to-cyan-600 text-white text-center py-2 text-sm font-semibold">
                  🔥 热门产品
                </div>
              )}
              
              <div className="relative overflow-hidden flex-shrink-0">
                <img 
                  src={product.image} 
                  alt={product.name}
                  className="w-full h-48 object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-4 left-4">
                  <span className="bg-teal-600 text-white px-3 py-1 rounded-full text-sm font-medium">
                    {product.category}
                  </span>
                </div>
              </div>

              <div className="p-6 flex flex-col flex-grow">
                <h3 className="text-xl font-bold text-gray-900 mb-2 min-h-[3.5rem] flex items-start">{product.name}</h3>
                <p className="text-gray-600 mb-4 leading-relaxed min-h-[4.5rem] line-clamp-3">{product.description}</p>
                
                <div className="mb-6 flex-grow">
                  <h4 className="text-sm font-semibold text-gray-900 mb-2">核心功能：</h4>
                  <div className="flex flex-wrap gap-2 min-h-[5rem]">
                    {product.features.map((feature, index) => (
                      <span key={index} className="bg-teal-50 text-teal-700 px-3 py-1 rounded-full text-sm h-fit">
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="flex items-center justify-between mt-auto pt-4 border-t border-gray-100">
                  <div className="min-w-[120px]">
                    <span className="text-2xl font-bold text-teal-600">{product.price}</span>
                  </div>
                  <Link
                    to={product.id === 1 ? "/adobe-pdf-library" : product.id === 3 ? "/pdf-forms-extension-sdk" : product.id === 4 ? "/pdf-forms-flattener" : product.id === 5 ? "/pdf-optimizer" : product.id === 6 ? "/adobe-indesign-server" : product.id === 7 ? "/pdf-rest-container" : "/adobe-pdf-converter"}
                    className="bg-teal-600 hover:bg-teal-700 text-white px-6 py-2 rounded-lg font-semibold transition-colors whitespace-nowrap cursor-pointer"
                  >
                    了解详情
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
